import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getProfileField } from '../translations/profileTranslation';


function FooterEdit() {
  const { t } = useTranslation();
  let LanguageSelected = Cookies.get('LanguageSelected');

  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');

  const apiUrl = process.env.REACT_APP_BACKEND_URL

  const [ToggleFooter, setToggleFooter] = useState()

  useEffect(() => {
    fetch(`${apiUrl}/GetComponentsOrder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${UserToken}`,
      },
      body: JSON.stringify({ user_id: userId }),
    })
      .then(response => response.json())
      .then(result => {
        setToggleFooter(result.ToggleFooter)
      });
  }, []);



  const navigate = useNavigate()



  const secretKey = 'vcard-secret-key';

  const encryptedUserId = btoa(userId.toString() + secretKey);

  const [ProfileContent, setProfileContent] = useState([])


  useEffect(() => {
    fetch(`${apiUrl}/GetProfileInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setProfileContent(result.data)
        }
      })
  }, [])


  const HandleLogOut = () => {
    fetch(`${apiUrl}/LogOut`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`

      },
    })
      .then(response => response.json())
      .then(result => {
        navigate(`/Profile/${encryptedUserId}`)
        Cookies.remove('userId');
        Cookies.remove('UserSpecialToken');

        window.location.reload()



        toast.success(result.message, {
          position: toast.POSITION.BOTTOM_CENTER
        });

      })
  }


  return (
    <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>
      <section className="footer-desktop m-3">
        <div className=" p-4 w-full  rounded-xl sections">
          <div className="pb-2">
            {parseInt(ToggleFooter) === 1 &&
            <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-2' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>PowerCard</h1>

            }
          </div>
          {parseInt(ToggleFooter) === 1 &&
            <p className={`review-item__caption text-left text-theme text-about-footer ${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>      {getProfileField(ProfileContent, 'first_name', LanguageSelected)} {t("et des milliers d'autres professionnels utilisent Powercard au quotidien pour rester en contact avec les personnes qu'ils rencontrent.")}
            </p>
          }

          <div className={`${parseInt(ToggleFooter) !== 1 ? 'grid grid-cols-1 gap-2 mt-4' : 'grid grid-cols-2 gap-2 mt-4'}`}>
            {
              parseInt(ToggleFooter) === 1 &&
              <a className="btn-footer font-semibold" href="https://www.getpowercard.com/" target="_blank">{t("Obtenir mon PowerCard")}</a>

            }

            <a className="btn-footer font-semibold" onClick={(e) => { HandleLogOut(e) }}>{t("Se déconnecter")}</a>

          </div>
          <div className="text flex-wrap font-semibold items-center justify-center ml-5 mr-2 mt-5">
            <p className="block text-center text-theme text-sm">
              Copyright © 2023 | Edited By <a href="https://www.syspower.ma " className="text-theme">SYSPOWER</a>
            </p>
            <p className="block text-center text-theme text-sm">All Rights Reserved</p>
          </div>
        </div>
      </section>


    </div>
  )
}

export default FooterEdit